module.exports = __webpack_public_path__ + "images/vaidyaaiebc83cc82b1003e4807c37797a171511.png";